import { render, staticRenderFns } from "./BetgameDescription.vue?vue&type=template&id=643c2e4c&scoped=true"
import script from "./BetgameDescription.vue?vue&type=script&lang=js"
export * from "./BetgameDescription.vue?vue&type=script&lang=js"
import style0 from "./BetgameDescription.vue?vue&type=style&index=0&id=643c2e4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643c2e4c",
  null
  
)

export default component.exports